import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportesService {
  private readonly apiUrl = environment.urlback;
  private readonly token: string = JSON.parse(
    localStorage.getItem('glpiToken') || '{}',
  ).token;

  constructor(private readonly http: HttpClient) {}

  obtenerReporteInventarioEquipos(
    tabla: string,
    filtros: any,
  ): Observable<Blob> {
    return this.http.post(
      `${this.apiUrl}/reportes/inventario-equipos`,
      { ...filtros },
      {
        params: { tabla, token: this.token },
        responseType: 'blob',
      },
    );
  }
}
